import React from 'react'
import { Link } from 'react-router-dom'

const loginFooter = () => ({
  left: <Link to='/users/confirmation/new'>Didn&apos;t receive confirmation instructions?</Link>,
})

export default loginFooter
